import CategoryFormModal from "./CategoryFormModal";
import {useModal} from "../../../store/admin/ModalProvider";
import ProductFormModal from "./ProductFormModal";
import SortableListModal from "./SortableListModal";
import QuestionModal from "./QuestionModal";

const ModalLookup = {
    CategoryFormModal: CategoryFormModal,
    ProductFormModal: ProductFormModal,
    SortableListModal: SortableListModal,
    QuestionModal: QuestionModal
}

const ModalManager = () => {
    const { modal, closeModal } = useModal();

    if (!modal) return null;
    const Modal = ModalLookup[modal.name];

    return <Modal onClose={closeModal} {...modal.props} />;
}

export default ModalManager;